<template>
    <div>
        <v-simple-table class="table-layout pa-5">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Tháng</th>
                        <th>Tiền lớp 1</th>
                        <th>Lớp 1</th>
                        <th>Lớp 2</th>
                        <th>Lớp 3</th>
                        <th>Lớp 4</th>
                        <th>Lớp 5</th>
                        <th>Lớp 6</th>
                        <th>Lớp 7</th>
                        <th>Lớp 8</th>
                        <th>Lớp 9</th>
                        <th>Lớp 10</th>
                        <th>Lớp 11</th>
                        <th>Lớp 12</th>
                    </tr>
                </thead>
                <tbody v-if="_.isArray(accountClassData) && accountClassData.length">
                    <template v-for="(item, index) in accountClassData">
                        <tr :key="index">
                            <td>{{ item.month }}</td>
                            <td>{{ formatPrice(item.tl1) }}</td>
                            <td>{{ formatPrice(item.l1) }}</td>
                            <td>{{ formatPrice(item.l2) }}</td>
                            <td>{{ formatPrice(item.l3) }}</td>
                            <td>{{ formatPrice(item.l4) }}</td>
                            <td>{{ formatPrice(item.l5) }}</td>
                            <td>{{ formatPrice(item.l6) }}</td>
                            <td>{{ formatPrice(item.l7) }}</td>
                            <td>{{ formatPrice(item.l8) }}</td>
                            <td>{{ formatPrice(item.l9) }}</td>
                            <td>{{ formatPrice(item.l10) }}</td>
                            <td>{{ formatPrice(item.l11) }}</td>
                            <td>{{ formatPrice(item.l12) }}</td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="100">
                            <common-no-result />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    props: {
        accountClassData: {
            type: Array,
            default: () => {[]}
        }
    }
}
</script>

<style scoped>
.table-layout tbody tr {
    height: 40px !important;
}

.table-layout th {
    font-size: 18px !important;
}

.table-layout td {
    font-size: 16px !important;
}
</style>